"use client";
import React, { useState } from "react";
import log from "logbeacon";
import { cn } from "utils";
import Translations from "@translate/components/AIInsight/TableOfContents";
import { I18nUtil } from "@utils/i18n";

const I18n = I18nUtil.createScoped(Translations);

// 目录项接口
interface TocItem {
  id: string;
  title: string;
  level: 1 | 2;
  children?: TocItem[];
}

interface TableOfContentsProps {
  toc: TocItem[];
  className?: string;
  // I18n: any;
}

export const TableOfContents = ({ toc }: TableOfContentsProps) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const onClickItem = (index: number, id: string, title: string) => {
    setActiveIndex(index);
    handleScrollToHeading(id, title);
  };
  if (toc.length === 0) {
    return null;
  }

  const handleScrollToHeading = (id: string, title: string) => {
    // 方法1：尝试通过ID查找（如果有的话）
    let element = document.getElementById(id);

    if (!element) {
      // 方法2：通过标题文本内容查找对应的标题元素
      const headings = document.querySelectorAll("h1, h2, h3, h4, h5, h6");
      element = Array.from(headings).find((heading) => {
        const headingText = heading.textContent?.trim().replace(/[^\w\s]/g, "");
        const titleText = title.trim().replace(/[^\w\s]/g, "");
        return headingText === titleText;
      }) as HTMLElement;
    }

    if (!element) {
      // 方法3：更宽松的文本匹配（包含关系）
      const headings = document.querySelectorAll("h1, h2, h3, h4, h5, h6");
      element = Array.from(headings).find((heading) => {
        const headingText = heading.textContent?.trim().toLowerCase() || "";
        const titleText = title.trim().toLowerCase();
        return (
          headingText.includes(titleText) || titleText.includes(headingText)
        );
      }) as HTMLElement;
    }

    if (element) {
      element.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });

      // 添加一个临时的高亮效果
      element.style.backgroundColor = "#fff3cd";
      element.style.transition = "background-color 0.3s ease";
      setTimeout(() => {
        element.style.backgroundColor = "";
      }, 2000);
    } else {
      log.warn(`[文案]无法找到标题: ${title}`);
    }
  };

  return (
    <div className="w-[252px]">
      <span className="text-content_primary title_l mt-[16px] block mb-[16px]">
        {I18n.t("Content")}
      </span>
      {toc?.map((item, index) => (
        <div
          data-openreplay-label="AIInsight · TableOfContents · div"
          key={item.id}
          onClick={() => onClickItem(index, item.id, item.title)}
          className={cn(
            "flex flex-row items-center  gap-[20px] cursor-pointer hover:bg-background_solid_primary_hover rounded-[4px] transition-colors",
            activeIndex === index && "bg-background_solid_primary_hover",
          )}
        >
          <div
            className={cn(
              "w-[0.5px] h-[56px] bg-background_white_overlay20",
              activeIndex === index && "bg-content_brand_primary w-[2px]",
            )}
          />
          <span
            style={{ alignItems: "center" }}
            className={cn(
              "h-[56px] text-content_primary line-clamp-2 overflow-hidden text-ellipsis title_l py-[8px] flex title_m",
              activeIndex === index && "text-content_brand_primary",
            )}
          >
            {(() => {
              const maxLength = 62;
              return item.title.length > maxLength
                ? item.title.substring(0, maxLength) + "..."
                : item.title;
            })()}
          </span>
        </div>
      ))}
    </div>
  );
};
